module.exports = __webpack_public_path__ + "static/app-icon-6adbfa2454ed206aa63fa0758ac5b16a.png";